export const TOP_LIMIT = 5;

export const useGetTopRows = ({ rows }) => {
  return (openRows) => {
    if (!openRows.length) {
      return rows
        .filter((row) => {
          return (
            !row.isTotalValue && // not total
            row.hierarchy.length === 1 // main rows
          );
        })
        .slice(0, TOP_LIMIT);
    }
    return openRows.slice(0, TOP_LIMIT).reduce((prevOpenRows, openRowId) => {
      return [
        ...prevOpenRows,
        ...rows
          .filter((row) => {
            return (
              !row.isTotalValue && // not total
              hierarchyToId(row.hierarchy.slice(0, -1)) === openRowId
            );
          })
          .slice(0, TOP_LIMIT),
      ];
    }, []);
  };
};

function hierarchyToId(hierarchy) {
  return hierarchy.join('///');
}
